// extracted by mini-css-extract-plugin
export default {"AsideItemDefault":"AsideItem_AsideItemDefault__clpYe","AsideItemHeader":"AsideItem_AsideItemHeader__HjxlE"};